import React from 'react';

const AssessmentContentCenteredSection = ({children}) => (
    <div className="assessment-content-centered-section">
        {children}
    </div>
)

export default AssessmentContentCenteredSection;